"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzCounterInput = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const index_1 = require("../../index");
const useResize_1 = require("../../hooks/useResize");
const className_1 = require("../../utils/className");
const transformSingularStringIntoPlural_1 = require("../../utils/transformSingularStringIntoPlural");
const Button_1 = require("../Button");
exports.VbzCounterInput = ({ id, mobileTitleModal, arrayOfItems, className, disabled = false, onChange = () => undefined, min, max, mobileLabel, mobileSubtitleModal, icon, confirmButtonText = 'Confirmar', desktopButtonId, confirmButtonId, submitForm, }) => {
    const containerRef = react_1.useRef(null);
    const { width } = useResize_1.useWindowSize();
    const [value, setValue] = react_1.useState([]);
    const [totalValue, setTotalValue] = react_1.useState(min);
    const [isShowModal, setIsShowModal] = react_1.useState(false);
    const [modalContainerIsOpen, setModalContainerIsOpen] = react_1.useState(false);
    react_1.useEffect(() => {
        setValue((prevState) => arrayOfItems.map(({ defaultValue, min: minValue }, index) => {
            if (prevState.length)
                return prevState[index];
            if (defaultValue && defaultValue > minValue) {
                return defaultValue;
            }
            return minValue;
        }));
        const initialTotalValue = arrayOfItems.reduce((total, { defaultValue, min: minValue }) => total + (defaultValue || minValue), 0);
        setTotalValue(initialTotalValue);
    }, [arrayOfItems]);
    react_1.useEffect(() => {
        function handleClickOutside(event) {
            var _a;
            if (event.target && !((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setIsShowModal(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const handleAddValue = (index) => {
        if (totalValue === max && !arrayOfItems[index].notIncludedTotalValue)
            return;
        if (arrayOfItems[index].maxCompareIndex !== undefined &&
            value[arrayOfItems[index].maxCompareIndex || 0] === value[index])
            return;
        const newTotalValue = !arrayOfItems[index].notIncludedTotalValue
            ? totalValue + 1
            : totalValue;
        const newValues = value.map((valueItem, indexItem) => {
            if (index === indexItem && valueItem !== arrayOfItems[index].max) {
                return valueItem + 1;
            }
            return valueItem;
        });
        setTotalValue(newTotalValue);
        setValue(newValues);
        const valuesToLog = arrayOfItems.map((dataItem, indexItem) => ({
            name: dataItem.counterName,
            value: newValues[indexItem],
        }));
        onChange([...valuesToLog, { name: 'Total', value: newTotalValue }]);
    };
    const handleSubValue = (index) => {
        if ((totalValue === min && !arrayOfItems[index].notIncludedTotalValue) ||
            value[index] === arrayOfItems[index].min)
            return;
        const newTotalValue = !arrayOfItems[index].notIncludedTotalValue
            ? totalValue - 1
            : totalValue;
        const newValues = value.map((valueItem, indexItem) => {
            if (index === indexItem && valueItem !== arrayOfItems[index].min) {
                return valueItem - 1;
            }
            if (arrayOfItems[indexItem].maxCompareIndex === index &&
                valueItem > value[index] - 1) {
                return value[index] - 1;
            }
            return valueItem;
        });
        setTotalValue(newTotalValue);
        setValue(newValues);
        const valuesToLog = arrayOfItems.map((dataItem, indexItem) => ({
            name: dataItem.counterName,
            value: newValues[indexItem],
        }));
        onChange([...valuesToLog, { name: 'Total', value: newTotalValue }]);
    };
    const handleSubmit = () => {
        const valuesToLog = arrayOfItems.map((dataItem, indexItem) => ({
            name: dataItem.counterName,
            value: value[indexItem],
        }));
        submitForm([...valuesToLog, { name: 'Total', value: totalValue }]);
        setIsShowModal(false);
        setModalContainerIsOpen(false);
    };
    return (react_1.default.createElement("div", { className: "vbz-counter-input" }, width < 992 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { type: "button", className: "mobile-card", onClick: () => setModalContainerIsOpen(true) },
            react_1.default.createElement("i", { className: "material-icons icon" }, icon),
            react_1.default.createElement("div", null,
                react_1.default.createElement("h3", null, mobileLabel),
                react_1.default.createElement("p", null, transformSingularStringIntoPlural_1.transformStringSingularIntoPlural({
                    data: arrayOfItems,
                    value,
                }))),
            react_1.default.createElement("i", { className: "material-icons arrow notranslate" }, "chevron_right")),
        react_1.default.createElement(index_1.VbzModal, { defaultHeader: false, isOpen: modalContainerIsOpen, type: "full" },
            react_1.default.createElement("div", { className: "dropdown-wrapper" },
                react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules([
                        'dropdown-content',
                        className,
                        disabled ? 'disabled' : '',
                        isShowModal ? '' : 'hidden',
                    ]) },
                    react_1.default.createElement("section", null,
                        react_1.default.createElement("button", { type: "button", className: "close", onClick: () => setModalContainerIsOpen(false) },
                            react_1.default.createElement("i", { className: "material-icons" }, "chevron_left")),
                        react_1.default.createElement("h1", null, mobileTitleModal),
                        mobileSubtitleModal && (react_1.default.createElement("span", { className: "description" }, mobileSubtitleModal)),
                        arrayOfItems.map((item, index) => (react_1.default.createElement("div", { className: "counter-item-container", key: item.counterName },
                            react_1.default.createElement("div", { className: "container-text" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("p", { className: "counter-name" }, item.counterName),
                                    item.warningMaxMessage && (react_1.default.createElement("div", { className: "warning-container" },
                                        react_1.default.createElement("i", { className: "material-icons notranslate" }, "info"),
                                        react_1.default.createElement("div", { className: "warning" },
                                            react_1.default.createElement("div", { className: "triangle" }),
                                            react_1.default.createElement("p", { id: item.warningMessageId }, item.warningMaxMessage))))),
                                item.description !== undefined && (react_1.default.createElement("span", null, item.description))),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("button", { type: "button", className: value[index] === item.min ||
                                        (!item.notIncludedTotalValue && totalValue === min)
                                        ? 'disabled'
                                        : '', onClick: () => handleSubValue(index) },
                                    react_1.default.createElement("i", { className: "material-icons" }, "remove")),
                                react_1.default.createElement("p", { className: value[index] === 0 ? 'value disabled' : 'value' }, value[index]),
                                react_1.default.createElement("button", { type: "button", className: value[index] === item.max ||
                                        (totalValue === max &&
                                            !item.notIncludedTotalValue) ||
                                        (item.maxCompareIndex !== undefined &&
                                            value[item.maxCompareIndex] === value[index])
                                        ? 'disabled'
                                        : '', onClick: () => handleAddValue(index) },
                                    react_1.default.createElement("i", { className: "material-icons" }, "add"))))))),
                    react_1.default.createElement(Button_1.VbzButton, { type: "button", className: "confirm-button", color: "primary", text: confirmButtonText, onClick: handleSubmit })))))) : (react_1.default.createElement("div", { className: "desktop-modal", ref: containerRef },
        react_1.default.createElement("button", { id: desktopButtonId, type: "button", onClick: () => setIsShowModal(!isShowModal), className: "button-desktop" },
            react_1.default.createElement("i", { className: "material-icons icon notranslate" }, icon),
            react_1.default.createElement("p", { className: "desktop-label" }, transformSingularStringIntoPlural_1.transformStringSingularIntoPlural({ data: arrayOfItems, value })),
            react_1.default.createElement("i", { className: "material-icons arrow notranslate" },
                ' ',
                isShowModal ? 'arrow_drop_up' : 'arrow_drop_down')),
        react_1.default.createElement("div", { className: "dropdown-wrapper" },
            react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules([
                    'dropdown-content',
                    className,
                    disabled ? 'disabled' : '',
                    isShowModal ? '' : 'hidden',
                ]) },
                react_1.default.createElement("section", null, arrayOfItems.map((item, index) => (react_1.default.createElement("div", { className: "counter-item-container", key: item.counterName },
                    react_1.default.createElement("div", { className: "container-text" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("p", { className: "counter-name", id: item.counterNameId }, item.counterName),
                            item.warningMaxMessage && (react_1.default.createElement("div", { className: "warning-container" },
                                react_1.default.createElement("i", { className: "material-icons notranslate" }, "info"),
                                react_1.default.createElement("div", { className: "warning" },
                                    react_1.default.createElement("div", { className: "triangle" }),
                                    react_1.default.createElement("p", null, item.warningMaxMessage))))),
                        item.description !== undefined && (react_1.default.createElement("span", { id: item.counterDescriptionId }, item.description))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("button", { id: item.counterMinusId, type: "button", className: value[index] === item.min ? 'disabled' : '', onClick: () => handleSubValue(index) },
                            react_1.default.createElement("i", { className: "material-icons" }, "remove")),
                        react_1.default.createElement("p", { id: item.counterValueId, className: value[index] === 0 ? 'value disabled' : 'value' }, value[index]),
                        react_1.default.createElement("button", { id: item.counterSumId, type: "button", className: value[index] === item.max ||
                                (totalValue === max && !item.notIncludedTotalValue) ||
                                (item.maxCompareIndex !== undefined &&
                                    value[item === null || item === void 0 ? void 0 : item.maxCompareIndex] === value[index])
                                ? 'disabled'
                                : '', onClick: () => handleAddValue(index) },
                            react_1.default.createElement("i", { className: "material-icons" }, "add"))))))),
                react_1.default.createElement(Button_1.VbzButton, { id: confirmButtonId, type: "button", className: "confirm-button", color: "primary", text: confirmButtonText, onClick: handleSubmit })))))));
};
//# sourceMappingURL=index.js.map